import { useEffect, useState } from "react";
import AdminListToolkit from "../../components/listing/AdminListToolkit";
import DataTable from "../../components/DataTable";
import AdminDataModal, { FormField } from "../../components/AdminDataModal";
import { useBusy } from "../../../context/BusyContext";
import { gtApi } from "../../api/generalTradeApi";

const fields: FormField[] = [
  { key: "customer_code", label: "Customer Code", disabled: true },
  { key: "company_name", label: "Company Name" },
  { key: "roc_number", label: "ROC Number" },
  { key: "brand", label: "Brand" },
  { key: "address", label: "Address", type: "textarea" },
  { key: "focal_person", label: "Focal Person" },
  { key: "phone_number", label: "Phone Number" },
  { key: "mobile_number", label: "Mobile Number" },
  { key: "email", label: "Email", type: "text" },
  {
    key: "status",
    label: "Status",
    type: "select",
    options: [
      { label: "Active", value: "active" },
      { label: "Inactive", value: "inactive" },
    ],
  },
];
const columns = [
  { key: "customer_code", label: "Code" },
  { key: "company_name", label: "Company" },
  { key: "brand", label: "Brand" },
  { key: "focal_person", label: "Focal Person" },
  { key: "mobile_number", label: "Mobile" },
  { key: "email", label: "Email" },
  { key: "status", label: "Status" },
];
export default function MaintainCustomers() {
  const { runBusy } = useBusy();

  const [rows, setRows] = useState<any[]>([]),
    [selected, setSelected] = useState<any>(null),
    [modal, setModal] = useState<any>(null);

  const load = async (): Promise<void> => {
    try {
      const customers = await runBusy(() => gtApi.customers());

      setRows(Array.isArray(customers) ? customers : []);
    } catch (error) {
      console.error("Failed to load General Trade customers:", error);
      setRows([]);
    }
  };

  useEffect(() => {
    void load();
  }, []);
  const save = async (data: any) => {
    modal.mode === "add"
      ? await gtApi.createCustomer(data)
      : await gtApi.updateCustomer(selected.id, data);
    setModal(null);
    load();
  };
  return (
    <>
      <AdminListToolkit
        title="MAINTAIN CUSTOMERS"
        columns={columns}
        data={rows}
        selectedRow={selected}
        onAdd={() => setModal({ mode: "add" })}
        onView={() => setModal({ mode: "view" })}
        onEdit={() => setModal({ mode: "edit" })}
        onSoftDelete={async () => {
          if (confirm("Deactivate selected customer?")) {
            await gtApi.deleteCustomer(selected.id);
            setSelected(null);
            load();
          }
        }}
        enableExport
        exportFileName="general-trade-customers"
      >
        {(filtered) => (
          <DataTable
            columns={columns}
            data={filtered}
            selectedRowId={selected?.id}
            onRowSelect={setSelected}
          />
        )}
      </AdminListToolkit>
      {modal && (
        <AdminDataModal
          isOpen
          mode={modal.mode}
          title="Customer"
          fields={fields}
          rowData={modal.mode === "add" ? { status: "active" } : selected}
          onClose={() => setModal(null)}
          onSubmit={save}
        />
      )}
    </>
  );
}
